<template>

    <div class="container" style="padding-top: 30px;">

        <BlockUI v-if="blockUI" message="Prosimo počakajte trenutek..." url="/images/loading-spinner.svg"></BlockUI>

        <div class="row">

            <div class="col-md-8 col-md-offset-2">

                <div class="panel panel-default">

                    <div class="panel-body">

                        <h3 class="text-center" style="margin-bottom:30px;">Partnerski program - Registracija</h3>


                        <vue-form-generator :model="model"
                                            :schema="affiliateTabSchema"
                                            :options="formOptions"
                                            ref="affiliateRegistrationForm"
                        >
                        </vue-form-generator>


                    </div>


                    <div class="panel-footer text-center">
                        <div class="btn btn-primary" @click="submit_form()">Oddaj prijavnico
                        </div>
                    </div>


                </div>
            </div>
        </div>
    </div>
</template>

<script>


    import VueFormGenerator from "vue-form-generator/dist/vfg.js";
    Vue.use(VueFormGenerator);

    import BlockUI from 'vue-blockui'
    Vue.use(BlockUI);


    export default {

        props: ["submit_url"],

        data: function () {
            return {

                blockUI: false,

                model: {
                    // customer
                    affiliate: {
                        first_name: '',
                        last_name: '',
                        email: ''
                    },

                    payout_type: 'business',

                    payout_data: {
                        business_name: '',
                        business_address: '',
                        business_vat: '',
                        business_trr: '',
                        individual_address: '',
                        individual_emso: '',
                        individual_vat: '',
                        individual_trr: '',
                    }

                },
                formOptions: {
                    validationErrorClass: "has-error",
                    validationSuccessClass: "has-success2",
                    validateAfterChanged: true
                },
                affiliateTabSchema: {
                    groups: [
                        {
                            fields: [
                                {
                                    type: "input",
                                    inputType: "text",
                                    label: "Ime",
                                    model: "affiliate.first_name",
                                    required: true,
                                    validator: VueFormGenerator.validators.string,
                                    styleClasses: 'col-sm-6'
                                },
                                {
                                    type: "input",
                                    inputType: "text",
                                    label: "Priimek",
                                    model: "affiliate.last_name",
                                    required: true,
                                    validator: VueFormGenerator.validators.string,
                                    styleClasses: 'col-sm-6'
                                },
                                {
                                    type: "input",
                                    inputType: "text",
                                    label: "Email",
                                    model: "affiliate.email",
                                    required: true,
                                    validator: VueFormGenerator.validators.email,
                                    styleClasses: 'col-sm-12'
                                },
                                {
                                    type: "input",
                                    inputType: "hidden",
                                    model: "payout_type",
                                    value: "business"

                                },
                                // {
                                //     type: "radios",
                                //     label: "Kakšen način plačila vam ustreza?",
                                //     model: "payout_type",
                                //     values: [
                                //         {value: "business", name: "PODJETJE"},
                                //         {value: "individual", name: "FIZIČNA OSEBA"},
                                //     ],
                                //     required: true,
                                //     styleClasses: 'col-sm-12',
                                //     validator: VueFormGenerator.validators.required
                                //
                                // },


                                {
                                    type: "input",
                                    inputType: "text",
                                    label: "Naziv podjetja",
                                    model: "payout_data.business_name",
                                    required: true,
                                    validator: VueFormGenerator.validators.string,
                                    styleClasses: 'col-sm-12',
                                    visible: function (model) {
                                        // waitlist only
                                        return model.payout_type === "business";
                                    }
                                },
                                {
                                    type: "input",
                                    inputType: "text",
                                    label: "Naslov podjetja",
                                    model: "payout_data.business_address",
                                    required: true,
                                    validator: VueFormGenerator.validators.string,
                                    styleClasses: 'col-sm-12',
                                    visible: function (model) {
                                        // waitlist only
                                        return model.payout_type === "business";
                                    }
                                },
                                {
                                    type: "input",
                                    inputType: "text",
                                    label: "Davčna številka",
                                    model: "payout_data.business_vat",
                                    required: true,
                                    validator: VueFormGenerator.validators.string,
                                    styleClasses: 'col-sm-12',
                                    visible: function (model) {
                                        // waitlist only
                                        return model.payout_type === "business";
                                    }
                                },
                                {
                                    type: "input",
                                    inputType: "text",
                                    label: "Transakcijski račun",
                                    model: "payout_data.business_trr",
                                    required: true,
                                    validator: VueFormGenerator.validators.string,
                                    styleClasses: 'col-sm-12',
                                    visible: function (model) {
                                        // waitlist only
                                        return model.payout_type === "business";
                                    }
                                },


                                {
                                    type: "input",
                                    inputType: "text",
                                    label: "Naslov",
                                    model: "payout_data.individual_address",
                                    required: true,
                                    validator: VueFormGenerator.validators.string,
                                    styleClasses: 'col-sm-12',
                                    visible: function (model) {
                                        // waitlist only
                                        return model.payout_type === "individual";
                                    }
                                },
                                {
                                    type: "input",
                                    inputType: "text",
                                    label: "Emšo",
                                    model: "payout_data.individual_emso",
                                    required: true,
                                    validator: VueFormGenerator.validators.string,
                                    styleClasses: 'col-sm-12',
                                    visible: function (model) {
                                        // waitlist only
                                        return model.payout_type === "individual";
                                    }
                                },
                                {
                                    type: "input",
                                    inputType: "text",
                                    label: "Davčna številka",
                                    model: "payout_data.individual_vat",
                                    required: true,
                                    validator: VueFormGenerator.validators.string,
                                    styleClasses: 'col-sm-12',
                                    visible: function (model) {
                                        // waitlist only
                                        return model.payout_type === "individual";
                                    }
                                },
                                {
                                    type: "input",
                                    inputType: "text",
                                    label: "Transakcijski račun",
                                    model: "payout_data.individual_trr",
                                    required: true,
                                    validator: VueFormGenerator.validators.string,
                                    styleClasses: 'col-sm-12',
                                    visible: function (model) {
                                        // waitlist only
                                        return model.payout_type === "individual";
                                    }
                                },


                            ]
                        }

                    ]
                }
            }
        },

        mounted() {


        },

        created() {

            VueFormGenerator.validators.resources.fieldIsRequired = "To polje je obvezno.";
            VueFormGenerator.validators.resources.invalidEmail = "Prosimo vpišite veljaven email naslov."
        },

        methods: {

            submit_form: function () {

                if (this.$refs.affiliateRegistrationForm.validate()) {

                    this.blockUI = true;

                    var self = this;

                    axios.post(this.submit_url, this.model)
                        .then(function (response) {


                            self.blockUI = false;

                                window.location = "https://prijavnica.savinaatai.com/partnerski-program/uspesna-registracija";

                        })
                        .catch(function (error) {

                            self.blockUI = false;
                            alert("Prišlo je do napake. Če se napaka ponavlja, nas prosimo kontaktirajte na savina@savinaatai.com.");

                        });


                }
            }

        },


        computed: {}


    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/affiliate/AffiliateRegister.vue